import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, UrlMatchResult, UrlSegment } from '@angular/router';

import { BoardComponent } from './board.component';


export function boardRouteMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length !== 2 && segments.length !== 3) {
    return null;
  }

  const [boardSegment, categorySegment, articleSegment] = segments;
  if (boardSegment.path !== 'board' || !categorySegment.path) {
    return null;
  }
  if (articleSegment && !articleSegment.path) {
    return null;
  }

  return {
    consumed: segments,
    posParams: {
      cat: categorySegment,
      ...(articleSegment ? {id: articleSegment} : {}),
    },
  };
}

const routes: Routes = [
  {
    matcher: boardRouteMatcher,
    component: BoardComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class BoardRoutingModule {}
